export default __webpack_public_path__ + "static/media/banner2.3cf97ce6.jpeg";